import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../primitives/Button/Button';
import './MainMenu.css';
import { DEV_ROOM_ID } from '../../../utils/constants';

const MainMenu: React.FC<{}> = ({ }) => {
  const navigate = useNavigate();

  const handleCreateRoom = useCallback(async () => {
    navigate('/room');
  }, [navigate]);

  const handleJoinRoom = useCallback(() => {
    navigate('/join');
  }, [navigate]);

  const handleSettings = useCallback(() => {
    navigate('/settings');
  }, [navigate]);

  const handleAltFramework = useCallback(() => {
    navigate(`/r3f?roomId:${DEV_ROOM_ID}`);
  }, [navigate]);

  return (
    <div className="root">
      <h1>Digital Den</h1>
      <div className='button-container'>
        <Button
          label="Create New Room"
          isSecondary={true}
          onClick={handleCreateRoom}
        />
        <Button
          label="Join Existing Room"
          isSecondary={true}
          onClick={handleJoinRoom}
        />
        <Button
          label="Settings"
          isSecondary={true}
          onClick={handleSettings}
        />
        {/* <Button
          label="R3F"
          isSecondary={true}
          onClick={handleAltFramework}
        /> */}
      </div>
    </div>
  );
};

export default MainMenu;
